import { render, staticRenderFns } from "./Loteria.vue?vue&type=template&id=0c7d202c&"
import script from "./Loteria.vue?vue&type=script&lang=js&"
export * from "./Loteria.vue?vue&type=script&lang=js&"
import style0 from "./Loteria.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports